<template>
  <div class="sign-page">
    <header class="navy">
      <nav>
        <div class="logo">
          <a href="#" style="margin-right: 2rem;" @click.prevent="$router.push('/')">
            <img src="@/assets/img/giupnuri_logo.png"/>
          </a>
          <!--Menu-->
<!--          <div class="menu">-->
<!--            <ul>-->
<!--              <li>-->
<!--                <a href="#">-->
<!--                  제품소개-->
<!--                </a>-->
<!--              </li>-->
<!--              <li>-->
<!--                <a href="#">-->
<!--                  고객사례-->
<!--                </a>-->
<!--              </li>-->
<!--              <li>-->
<!--                <a href="#">-->
<!--                  서비스 문의-->
<!--                </a>-->
<!--              </li>-->
<!--            </ul>-->
<!--          </div>-->
        </div>
        <div class="sign">
          <ul>
            <li>
              <a href="#" @click.prevent="$router.push('/account/sign')">
                회원가입
              </a>
            </li>
            <li>
              <a href="#" @click.prevent="$router.push('/account/login')">
                로그인
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </header>
    <!--end::header-->
    <section>
      <article>
        <div class="box_A">
          <h1>
            회원가입
          </h1>
          <p>
            간단한 회원 가입을 통해<br>
            기업누리의 원스톱 서비스를 이용해보세요
          </p>
          <div class="signup_form">
            <form>
              <div :class="{fals: $v.params.userID.$error}">
                <input type="text" :class="{'is-invalid': $v.params.userID.$error}" v-model="params.userID">
                <span>아이디 *</span>
                <p class="pw_fals" v-show="$v.params.userID.$error">{{ valid.msg.userID }}</p>
              </div>
              <div :class="{fals: $v.params.userPWD.$error}">
                <input type="password" :class="{'is-invalid': $v.params.userPWD.$error}" v-model="params.userPWD">
                <span>비밀번호 *</span>
                <p class="pw_fals" v-show="$v.params.userPWD.$error">{{ valid.msg.userPWD }}</p>
              </div>
              <div :class="{fals: $v.params.userPWDConfirm.$error}">
                <input type="password" :class="{'is-invalid': $v.params.userPWDConfirm.$error}" v-model="params.userPWDConfirm">
                <span>비밀번호 확인 *</span>
                <p class="pw_fals" v-show="$v.params.userPWDConfirm.$error">{{ valid.msg.userPWDConfirm }}</p>
              </div>
              <div :class="{fals: $v.params.companyName.$error}">
                <input type="text" :class="{'is-invalid': $v.params.companyName.$error}" v-model="params.companyName">
                <span>회사명 *</span>
                <p class="pw_fals" v-show="$v.params.companyName.$error">{{ valid.msg.companyName }}</p>
              </div>
              <div :class="{fals: $v.params.companyNumber.$error}">
                <input type="text" :class="{'is-invalid': $v.params.companyNumber.$error}" v-model="params.companyNumber" @input="params.companyNumber = $Util.numberOnly2(params.companyNumber)">
                <span>사업자등록번호 *</span>
                <p class="pw_fals" v-show="$v.params.companyNumber.$error">{{ valid.msg.companyNumber }}</p>
              </div>
              <div :class="{fals: $v.params.companyFax.$error}">
                <input type="text" :class="{'is-invalid': $v.params.companyFax.$error}" v-model="params.companyFax" @input="params.companyFax = $Util.numberOnly2(params.companyFax)">
                <span>팩스번호</span>
                <p class="pw_fals" v-show="$v.params.companyFax.$error">{{ valid.msg.companyFax }}</p>
              </div>
              <div :class="{fals: $v.params.companyAddress1.$error}" class="with-button">
                <input type="text" v-model="params.companyAddress1" @click="fnSearch" readonly>
                <span class="readonly">소재지 *</span>
                <button type="button" @click="fnSearch">주소검색</button>
                <p class="pw_fals addon" v-show="$v.params.companyAddress1.$error">{{ valid.msg.companyAddress1 }}</p>
              </div>
              <div :class="{fals: $v.params.companyAddress2.$error}">
                <input type="text" v-model="params.companyAddress2">
                <span>상세주소 *</span>
                <p class="pw_fals" v-show="$v.params.companyAddress2.$error">{{ valid.msg.companyAddress2 }}</p>
              </div>
              <div :class="{fals: $v.params.contactName.$error}">
                <input type="text" :class="{'is-invalid': $v.params.contactName.$error}" v-model="params.contactName">
                <span>담당자(대표자) 명 *</span>
                <p class="pw_fals" v-show="$v.params.contactName.$error">{{ valid.msg.contactName }}</p>
              </div>
              <div :class="{fals: $v.params.contactEmail.$error}">
                <input type="text" :class="{'is-invalid': $v.params.contactEmail.$error}" v-model="params.contactEmail">
                <span>담당자(대표자) E-Mail *</span>
                <p class="pw_fals" v-show="$v.params.contactEmail.$error">{{ valid.msg.contactEmail }}</p>
              </div>
              <div :class="{fals: $v.params.contactPhone.$error}" class="with-button">
                <input type="text" v-model="params.contactPhone" @input="params.contactPhone = $Util.numberOnly2(params.contactPhone)">
                <span>담당자(대표자) 연락처 *</span>
                <button type="button" @click="sendPhoneAuth">{{ sendPhoneAuthText }}</button>
                <p class="pw_fals addon" v-show="$v.params.contactPhone.$error">{{ valid.msg.contactPhone }}</p>
              </div>
              <div class="with-button addon" v-if="isSendAuth" :disabled="isConfirmAuth">
                <input type="text" v-model="params.authCode" placeholder="인증코드 입력" :readonly="isConfirmAuth">
                <span class="count" v-show="!isConfirmAuth">{{ timer }}</span>
                <button type="button" @click="confirmPhoneAuthCode" :disabled="isConfirmAuth">확인</button>
              </div>
              <div>
                <input type="text" v-model="params.contactDepartment">
                <span>담당자 부서</span>
              </div>
              <div>
                <input type="text" v-model="params.contactTel">
                <span>담당자 직통번호</span>
              </div>
            </form>
            <form class="bottom_form">
              <div class="flex_box">
                <div class="input_box">
                  <input type="checkbox" id="termsService" v-model="termsService.value">
                </div>
                <div class="form_txt_1">
                  <label for="termsService">[필수] 서비스 이용약관</label>
                  <p v-show="termsService.value === false">필수 동의 항목입니다.</p>
                </div>
                <div class="form_txt_2" @click="showTermsService" style="cursor: pointer;">약관보기</div>
              </div>
              <div class="flex_box">
                <div class="input_box">
                  <input type="checkbox" id="termsPrivacy" v-model="termsPrivacy.value">
                </div>
                <div class="form_txt_1">
                  <label for="termsPrivacy">[필수] 개인정보 처리방침</label>
                  <p v-show="termsPrivacy.value === false">필수 동의 항목입니다.</p>
                </div>
                <div class="form_txt_2" @click="showTermsPrivacy" style="cursor: pointer;">약관보기</div>
              </div>
              <div class="btn">
                <button type="button" @click.prevent="registUser">
                  회원가입
                </button>
              </div>
            </form>
          </div>
        </div>
      </article>
    </section>

    <layout-footer></layout-footer>

    <address-modal v-bind:isShow="addressModalProp.isShow"
                   v-bind:callBack="fnBindAddress"
                   v-on:eventClose="fnClose">
    </address-modal>
    <terms-service-modal v-bind:isShow="termsService.isShow"
                         v-bind:callBack="() => {}"
                         v-on:eventClose="() => {termsService.isShow = false}">
    </terms-service-modal>
    <terms-privacy-modal v-bind:isShow="termsPrivacy.isShow"
                         v-bind:callBack="() => {}"
                         v-on:eventClose="() => {termsPrivacy.isShow = false}">
    </terms-privacy-modal>

  </div>
</template>
<script>
import required from "vuelidate/lib/validators/required";

export default {
  data: function () {
    return {
      termsService: {
        value: true,
        isShow: false,
      },
      termsPrivacy: {
        value: true,
        isShow: false,
      },
      addressModalProp: {
        isShow: false,
      },

      valid: {
        msg: {
          required: '필수 항목 입니다.',
        }
      },
      expired: false,
      timer: '5:00',
      sendPhoneAuthText: '인증',
      countDownInterval: null,
      isSendAuth: false,
      isConfirmAuth: false,
      params: {
        userID: '',
        userPWD: '',
        userPWDConfirm: '',
        userType: 1,
        joinType: 10,
        companyName: '',
        companyNumber: '',
        companyAddress1: '',
        companyAddress2: '',
        companyFax: '',
        companyOwner: '',
        companyOwnerPhone: '',
        companyOwnerEmail: '',
        contactName: '',
        contactDepartment: '',
        contactTel: '',
        contactPhone: '',
        contactEmail: '',
      },
    }
  },
  validations: {
    params: {
      userID: {
        test: function (val) {
          if (!required(val)) {
            this.valid.msg.userID = this.valid.msg.required
            return false
          }
          if (!this.$Util.isPasswordValid(val)) {
            this.valid.msg.userID = '영문자, 숫자 혼합 8~15자 이내로 입력해주세요.'
            return false
          }
          return true
        }
      },
      userPWD: {
        test: function (val) {
          if (!required(val)) {
            this.valid.msg.userPWD = this.valid.msg.required
            return false
          }
          if (!this.$Util.isPasswordValid(val)) {
            this.valid.msg.userPWD = '영문자, 숫자 혼합 8~15자 이내로 입력해주세요.'
            return false
          }
          return true
        }
      },
      userPWDConfirm: {
        test: function (val) {
          if (!required(val)) {
            this.valid.msg.userPWDConfirm = this.valid.msg.required
            return false
          }
          if (this.params.userPWD !== val) {
            this.valid.msg.userPWDConfirm = '위의 비밀번호와 동일하게 입력해주세요.'
            return false
          }
          return true
        }
      },
      companyName: {
        test: function (val) {
          if (!required(val)) {
            this.valid.msg.companyName = this.valid.msg.required
            return false
          }

          return true
        }
      },
      companyNumber: {
        test: function (val) {
          if (!required(val)) {
            this.valid.msg.companyNumber = this.valid.msg.required
            return false
          }

          return true
        }
      },
      companyAddress1: {
        test: function (val) {
          if (!required(val)) {
            this.valid.msg.companyAddress1 = this.valid.msg.required
            return false
          }

          return true
        }
      },
      companyAddress2: {
        test: function (val) {
          if (!required(val)) {
            this.valid.msg.companyAddress2 = this.valid.msg.required
            return false
          }

          return true
        }
      },
      companyFax: {
        test: function (val) {
          return true
        }
      },
      contactName: {
        test: function (val) {
          if (!required(val)) {
            this.valid.msg.contactName = this.valid.msg.required
            return false
          }
          return true
        }
      },
      contactDepartment: {
        test: function (val) {
          return true
        }
      },
      contactEmail: {
        test: function (val) {
          if (!required(val)) {
            this.valid.msg.contactEmail = this.valid.msg.required
            return false
          }
          return true
        }
      },
      contactPhone: {
        test: function (val) {
          if (!required(val)) {
            this.valid.msg.contactPhone = this.valid.msg.required
            return false
          }
          return true
        }
      },
      contactTel: {
        test: function (val) {
          return true
        }
      }
    }
  },
  watch: {
    'params.contactPhone': function () {
      this.isConfirmAuth = false
      this.params.authCode = ''
      this.timer = '5:00'
      this.isSendAuth = false
    },
  },
  created: function () {
  },
  methods: {
    showTermsService: function () {
      this.termsService.isShow = true
    },
    showTermsPrivacy: function () {
      this.termsPrivacy.isShow = true
    },
    fnSearch: function () {
      this.addressModalProp.isShow = true
      // const _this = this
      // this.$store.commit('layout/setModal', {
      //   modalName: 'address-modal', data: {title: '주소 검색'}, callBack: function (item) {
      //     setTimeout(function () {
      //       _this.fnBindAddress(item)
      //     }, 200)
      //   }
      // })
    },
    fnBindAddress: function (item) {
      this.params.companyAddress1 = item.roadAddress
      // this.params.userAddress2 = item.roadAddress
    },
    fnClose: function () {
      // alert('fnClose')
      this.addressModalProp.isShow = false
    },
    sendPhoneAuth: function () {
      if (this.params.contactPhone.length <= 0) {
        alert('담당자 휴대폰번호를 입력해주세요.')
        return false
      }

      if (!this.$Util.isPhoneValid(this.params.contactPhone)) {
        alert('올바른 담당자 휴대폰번호를 입력해주세요.')
        return false
      }

      let params = {
        authType: 1,
        contactPhone: this.params.contactPhone
      }

      this.$CommonSvc.sendPhoneAuth(params)
        .then(res => {
          const code = res.code
          const message = res.message
          const entity = res.entity

          console.log('code: {%d}, message: {%s}, entity: %o', code, message, entity)
          if (code === 1) {
            alert('인증코드가 발송 되었습니다.')
            this.params.authToken = entity.authToken
            this.params.authCode = ''
            this.isConfirmAuth = false
            this.isSendAuth = true
            this.sendPhoneAuthText = '재인증'
            this.expired = false
            this.timer = '5:00'
            this.countDown()
          } else {
            alert(message)
          }
        })
    },
    countDown: function () {
      clearInterval(this.countDownInterval)
      let duration = this.$moment.duration({
        'minutes': '5',
        'seconds': '00'
      })
      const _this = this
      this.countDownInterval = setInterval(function () {
        duration = _this.$moment.duration(duration.asSeconds() - 1, 'seconds')
        let min = duration.minutes()
        let sec = duration.seconds()
        if (Number(sec) < 0) {
          _this.timer = '0:00'
          _this.expired = true
          clearInterval(_this.countDownInterval)
          return false
        }
        if (sec < 10) {
          sec = '0' + sec
        }

        _this.timer = min + ':' + sec
      }, 1000)
    },
    confirmPhoneAuthCode: function () {
      if (this.expired) {
        alert('인증시간이 만료되었습니다.\n재 인증 해주세요.')
        return false
      }

      if (this.params.authCode.length <= 0) {
        alert('인증코드를 입력해주세요.')
        return false
      }

      let params = {
        userPhone: this.params.userPhone,
        authCode: this.params.authCode,
        authToken: this.params.authToken
      }

      this.$CommonSvc.confirmPhoneAuthCode(params)
        .then(res => {
          const code = res.code
          const message = res.message
          const entity = res.entity

          console.log(entity)
          if (code === 1) {
            alert('인증 되었습니다.')
            this.isConfirmAuth = true
            clearInterval(this.countDownInterval)
          } else {
            alert(message)
          }
        })
    },
    registUser: function () {
      this.$v.$touch()
      if (!this.$Util.isValid(this.$v, this.$el)) {
        return false
      }

      if (!this.isConfirmAuth) {
        alert('연락처 인증절차를 완료 해주세요.')
        return false
      }

      if (this.params.companyAddress1.length <= 0 || this.params.companyAddress2.length <= 0) {
        alert('소재지 주소를 입력해주세요.')
        return false
      }

      if (!this.termsService || !this.termsPrivacy) {
        alert('필수 약관에 동의해주세요.')
        return false
      }

      this.$AccountSvc.join(this.params)
        .then(res => {
          const code = res.code
          const message = res.message
          const entity = res.entity

          // console.log('code: {%d}, message: {%s}, entity: %o', code, message, entity)
          if (code === 1) {
            alert('회원가입이 완료되었습니다.\n관리자 승인 후 서비스 이용이 가능합니다.')
            this.$router.push('/')
          } else {
            if (this.$Util.isEmpty(message)) {
              alert('네트워크 에러가 발생했습니다.\n잠시 후 다시 시도해주세요.')
            } else {
              alert(message)
            }
          }
        })
    },
  }
}
</script>
